import { toast } from "react-toastify";
import { _single, _TaxableBase, _TaxSchemeValue, _TaxSchemeValueArticleType } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { TaxableArticleTypesEditor } from "./TaxableArticleTypes.editor";
import { SelectAccountantTree } from "../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";

interface Props {
    idTaxSchemeValue: any;
    _onChange?: Function;
}

export const TaxSchemeValueArticleType = ({ idTaxSchemeValue, _onChange }: Props) => {

    const { setBean, bean, lista, setLista, instance } = useDataBean(_TaxSchemeValueArticleType);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true });
    const [modalAdd, setModalAdd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true });


    useEffect(() => {
        if (idTaxSchemeValue) {
            getLista()
        }
    }, [idTaxSchemeValue])

    useEffect(() => {
        if (_onChange) {
            _onChange(bean)
        }
    }, [bean])

    const head = [
        { title: 'ID', property: 'IDTaxSchemeValueArticleType', visible: true },
        { title: 'Cuenta Contable Descuento', property: 'AccountantIDName', visible: true, },
        { title: 'Cuenta Contable Vr Agregado', property: 'AccountantIDAddedValueName', visible: true },
        { title: 'Cuenta Contable Consumo', property: 'AccountantIDOwnConsumptionName', visible: true },
        { title: 'Tipo de Articulo', property: 'AdquisitionArticleTypeName', visible: true },
    ]

    const create = () => {
        setBean({});
        setModalAdd({ ...modalAdd, "format": 'modal-md', "name": "Agregar Cuentas Contables", "view": true });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": "Editar Tarifa de Impuesto", "format": 'modal-lg', "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getLista = () => {
        instance.getTaxSchemeValueArticleTypeCatalog(idTaxSchemeValue).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const updateItem = () => {
        instance.updateTaxSchemeValueArticleType(bean).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteTaxSchemeValueArticleType(bean.IDTaxSchemeValueArticleType).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }

    const addTaxSchemeArticle = () => {
        instance.addArticleTypeToTaxSchemeValue(idTaxSchemeValue, bean.AdquisitionArticleType).then(
            (resp) => {
                getLista();
                setModalAdd({ ...modalAdd, "view": false });
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    return (
        <div className="row">
            <div className="col-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateItem} >
                    <div className="row">
                        <div className="col-md-12">
                            <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} jsonCode={bean.AccountantIDStr} label="Cuenta Contable Descuento" />
                        </div>
                        <div className="col-md-12">
                            <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "AccountantIDAddedValueStr": e.JsonCode }) }} jsonCode={bean.AccountantIDAddedValueStr} label="Cuenta Contable Vr Agregado" />
                        </div>
                        <div className="col-md-12">
                            <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "AccountantIDOwnConsumptionStr": e.JsonCode }) }} jsonCode={bean.AccountantIDOwnConsumptionStr} label="Cuenta Contable Consumo" />
                        </div>
                        <div className="col-md-12">
                            <TaxableArticleTypesEditor idSelector={bean.AdquisitionArticleType} onChange={(e) => { setBean({ ...bean, "AdquisitionArticleType": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalAdd} updateModal={setModalAdd} eventModal={addTaxSchemeArticle}>
                    <div className="row">
                        <div className="col-md-12">
                            <TaxableArticleTypesEditor idSelector={bean.AdquisitionArticleType} onChange={(e) => { setBean({ ...bean, "AdquisitionArticleType": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <></>
                </ModalConfirm>
            </div>
        </div>
    )
}